import { forwardRef, type ReactNode } from "react";
import styles from "./TaskWindow.module.css";

/** Ventana de tarea (TaskWindow.razor): un <dialog> nativo con el mismo HTML; quien la usa la abre y la cierra. */
export const TaskWindow = forwardRef<HTMLDialogElement, { className?: string; titleId: string; children: ReactNode }>(
  function TaskWindow({ className, titleId, children }, ref) {
    return (
      <dialog className={`bh-task-window ${className ?? ""} ${styles.scope}`} ref={ref} aria-labelledby={titleId}>
        {children}
      </dialog>
    );
  },
);

/** Pregunta descartar cambios con la ventana de Bheli (confirmDiscard del portal actual): resuelve true si descarta. */
export function confirmDiscard(dialog: HTMLDialogElement): Promise<boolean> {
  return new Promise((resolve) => {
    const previous = document.activeElement as HTMLElement | null;
    dialog.returnValue = "keep";
    dialog.addEventListener(
      "close",
      () => {
        previous?.focus();
        resolve(dialog.returnValue === "discard");
      },
      { once: true },
    );
    dialog.showModal();
    dialog.querySelector<HTMLElement>("button")?.focus();
  });
}

export function resolveDiscard(dialog: HTMLDialogElement, discard: boolean): void {
  dialog.close(discard ? "discard" : "keep");
}
